import { AlgorithmListResponse } from '@/types/service-response'

export class AlgorithmList {
  private constructor(
      readonly id: number,
      readonly createdAt: string,
      readonly tenant: string,
      readonly name: string,
  ) {}

  static createFromResponse(responseData: AlgorithmListResponse[]): AlgorithmList[] {
    return responseData.map((item: AlgorithmListResponse) => {
      return new AlgorithmList(
          item.id,
          item.createdAt,
          item.tenant,
          item.name
        )
      })
  }
}



